export const isProjectOwnedByUser = (project, user) => {
  if (!project || !user) {
    return false;
  }

  const toStringSafe = (value) => {
    if (value === undefined || value === null) {
      return "";
    }
    return String(value);
  };

  const normalizePublisherId = (value) => {
    if (!value) {
      return "";
    }
    return value.replace(/^publisher-/, "");
  };

  const userId = toStringSafe(user.id);
  const projectOwnerId = toStringSafe(project.createdByUserId);
  const legacyOwner = toStringSafe(project.createdBy);
  const username = toStringSafe(user.username);
  const email = toStringSafe(user.email);

  if (userId && projectOwnerId && userId === projectOwnerId) {
    return true;
  }

  if (legacyOwner) {
    if (username && (legacyOwner === username || normalizePublisherId(legacyOwner) === username)) {
      return true;
    }

    if (email && (legacyOwner === email || normalizePublisherId(legacyOwner) === email)) {
      return true;
    }
  }

  return false;
};
